module.exports = __webpack_public_path__ + "static/media/twoStar.c5504996.png";